var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('img',{staticStyle:{"width":"350px"},attrs:{"src":require("../assets/cap_loading.gif")}})])
}]

export { render, staticRenderFns }